export const APPLE_PAY_ALLOWED_NETWORKS = [
  'amex',
  'cartesBancaires',
  'chinaUnionPay',
  'discover',
  'eftpos',
  'electron',
  'elo',
  'interac',
  'jcb',
  'mada',
  'maestro',
  'masterCard',
  'privateLabel',
  'visa',
  'vPay'
].map(brand => brand.toLowerCase());

export const DEFAULT_APPLE_PAY_VERSION = 2;

export const APPLE_PAY_LOGO_CSS_SELECTOR = 'apple-pay-button-black';
